function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.4315 34.094C13.0419 35.0318 14.4661 35.0318 15.0765 34.094C24.9785 20.027 26.8097 18.5533 26.8097 13.3284C26.8097 6.22794 20.977 0.467163 13.7879 0.467163C6.53098 0.467163 0.766113 6.22794 0.766113 13.3284C0.766113 18.5533 2.52948 20.027 12.4315 34.094ZM13.7879 18.6873C10.7359 18.6873 8.36217 16.3428 8.36217 13.3284C8.36217 10.3811 10.7359 7.96957 13.7879 7.96957C16.7721 7.96957 19.2137 10.3811 19.2137 13.3284C19.2137 16.3428 16.7721 18.6873 13.7879 18.6873Z",
  fill: "#1D2A30"
});

var SvgPin = function SvgPin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 35,
    viewBox: "0 0 27 35",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pin.dd7aff8b.svg";
export { ForwardRef as ReactComponent };